<template>
  <div style="display: flex; width: 100%; gap: 10px; align-items: center;">
    <div style="display: flex; gap: 10px; width: 100%;" :style="getIsMobile() ? { gap: '3px', overflowX: 'auto', flexDirection: 'column' } : {}">
      <div style="display: flex; gap: 10px; align-items: center;" :style="getIsMobile() ? { width: '100%', justifyContent: 'space-between' } : {}">
        <input
          id="startFilter"
          type="date"
          v-model="Statistics_StartDate"
          :max="Statistics_EndDate"
          style="width: 230px;"
          :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
        />
        ~
        <input
          id="endFilter"
          type="date"
          v-model="Statistics_EndDate"
          :min="Statistics_StartDate"
          :max="ConvertDateTimeString(nowDate, 'YYYY-MM-DDTHH:MM')"
          style="width: 230px;"
          :style="getIsMobile() ? { fontSize: '11px', width: '160px' } : {}"
        />
      </div>
      <div class="button-group" style="width: 110px;">
        <button type="button" @click.stop="updateChartData()" class="action-button" :style="getIsMobile() ? {height: '39px', padding: '0', fontSize: '10px'} : {}">{{ $t('search') }}</button>
      </div>
    </div>
    <div class="button-group" v-show="!getIsMobile()">
      <button class="white-button" @click="exportToExcel(deviceList, Statistics_StartDate, Statistics_EndDate)" style="display: flex; gap: 5px;">
        {{ $t('excel_download') }}
        <img src="@/assets/images/download_blue.svg"/>
      </button>
    </div>
  </div>

  <!-- #region 접속 통계 -->
  <div style="display: flex; flex-direction: column; align-items: center; gap: 10px; height: calc(100% - 380px); padding-top: 10px;">
    <canvas ref="accessorChartCanvas" style="width: 100%; height: 300px; border-radius: 20px; border: 1px solid #D9D9D9;" :style="getIsMobile() ? { height: '370px', maxHeight: '370px' } : { height: '300px', maxHeight: '300px' }"></canvas>
  </div>
  <!-- #endregion -->

   <!-- 테이블 + 페이지네이션 -->
  <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
    <table style="height: 290px; max-height: 290px; overflow-y: unset; padding: 0;">
      <thead>
        <tr>
          <th class="w40p" style="cursor: default;">
            {{ $t('date') }}
          </th>
          <th class="w30p" style="cursor: default;">
            {{ $t('accessor_count') }}
          </th>
          <th class="w30p" style="cursor: default;">
            {{ $t('non-connected_count') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="([date, accesses, index]) in paginatedData" :key="date">
          <td :title="date" class="w40p" @click.stop="" style="cursor: default;">
            {{ date }}
          </td>
          <td :title="Array.from(accesses).length" class="w30p" style="cursor: default;">
            {{ Array.from(accesses).length }}
          </td>
          <td :title="accessorChartData.datasets[1].data[(accessCountMapArray.length === 1 ? index + 1 : index)] - Array.from(accesses).length" class="w30p" @click.stop="" style="cursor: default;">
            {{ accessorChartData.datasets[1].data[(accessCountMapArray.length === 1 ? index + 1 : index)] - Array.from(accesses).length }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination-control" style="">
      <div>
        <img src="@/assets/images/double_arrow_left_gray.svg" @click.stop="prevPagePer" v-show="currentPage !== 1"/>
        <img src="@/assets/images/arrow_left_gray.svg" @click.stop="prevPage" v-show="currentPage !== 1"/>
      </div>
      <span v-for="page in currentPageRange" :key="page" @click.stop="currentPage = page" :class="{ selected: currentPage === page }" :style="currentPage === page ? {cursor: 'default'} : {}">{{ page }}</span>
      <div>
        <img src="@/assets/images/arrow_right_gray.svg" @click.stop="nextPage" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
        <img src="@/assets/images/double_arrow_right_gray.svg" @click.stop="nextPagePer" v-show="(currentPage !== totalPages) && totalPages !== 0"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';
import i18n from '@/i18n';
import { Chart, registerables } from "chart.js";
import { device_list, GET_SERVER_REQUEST } from '@/utils/ServerConnect';
import { ConvertDateTimeString, getIsMobile } from '@/utils/GlobalUtility';
import { currentDate, datetimeRange, fontSizeAxis, fontSizeTitle, getDateRange, nowDate, Statistics_EndDate, Statistics_StartDate } from '@/utils/StatisticsUtility';
import { loadingStore } from '@/utils/LoadingStore';

Chart.register(...registerables);
const tableData = ref(null);
const chartInstance = ref(null);
const location_list = ref([]);

// 날짜별 접속자 수 (중복 제거)
const accessorChartCanvas = ref(null);
const accessCountMap = ref(new Map());
const accessCountMapArray = ref(null);
const accessorChartData = ref({
  labels: [],
  datasets: [
    {
      label: i18n.global.t('accessor_count'),
      data: [],
      borderColor: 'green',
      borderWidth: 2,
      pointBorderColor: '#FFF', // 데이터 포인트 테두리 색상
      pointBackgroundColor: 'green', // 데이터 포인트 색상
      pointRadius: 5, // 데이터 포인트 크기
    },
    {
      label: i18n.global.t('non-connected_count'),
      data: [],
      borderColor: 'orange',
      borderWidth: 2,
      pointBorderColor: '#FFF', // 데이터 포인트 테두리 색상
      pointBackgroundColor: 'orange', // 데이터 포인트 색상
      pointRadius: 5, // 데이터 포인트 크기
    },
  ],
});
const accessorChartOptions = ref({
  responsive: true,
  plugins: {
    title: {
      display: true,  // 제목을 표시할지 여부
      text: '사용자 현황',  // 제목 내용
      font: {
        size: fontSizeTitle.value,  // 제목 폰트 크기
        weight: 'bold',  // 제목 폰트 굵기
      },
      color: '#333',  // 제목 색상
    },
    legend: {
      display: false, // 범례 표시 여부
    },
  },
  scales: {
    x: {
      title: {
        display: true,  // X축 제목을 표시할지 여부
        // text: i18n.global.t('date'),  // X축 제목
        font: {
          size: fontSizeAxis.value,  // X축 제목 폰트 크기
        },
        color: '#000',  // X축 제목 색상
      },
      // offset: true, // X축 중앙 정렬 효과
    },
    y: {
      title: {
        display: true,  // Y축 제목을 표시할지 여부
        // text: i18n.global.t('count'),  // Y축 제목
        font: {
          size: fontSizeAxis.value,  // Y축 제목 폰트 크기
        },
        color: '#000',  // Y축 제목 색상
      },
      beginAtZero: true,  // Y축 0부터 시작
    },
  },
});
const setAccess = async () => {
  accessorChartData.value.labels = getDateRange();

  const newAccessMap = new Map();
  accessorChartData.value.labels.forEach(dateStr => {
    newAccessMap.set(dateStr, new Set());
  })

  location_list.value.forEach(log => {
    const date = ConvertDateTimeString(new Date(log.timestamp), "YYYY-MM-DD HH:MM:SS").split(' ')[0];
    const deviceId = log.device_id;
    if (newAccessMap.has(date)) {
      newAccessMap.get(date).add(deviceId);
    }
  });

  accessCountMap.value = newAccessMap;

  accessCountMapArray.value = Array.from(accessCountMap.value.entries())
  .sort(([dateA], [dateB]) => new Date(dateA).getTime() - new Date(dateB).getTime())
  .map((item, index) => {
    // item은 [date, accesses] 형태의 배열입니다.
    // 여기에 index를 추가하여 [date, accesses, index] 형태로 만듭니다.
    return [...item, index];
  });

  accessorChartData.value.datasets[0].data = accessorChartData.value.labels.map(date => accessCountMap.value.get(date)?.size || 0);
  accessorChartData.value.datasets[1].data = accessorChartData.value.labels.map(targetDateStr => {
    // 현재 계산하려는 날짜 (targetDateStr: "2025-03-06")
    // 날짜 비교를 위해 Date 객체로 변환합니다.
    const targetDate = new Date(targetDateStr);

    let count = 0;
    // device_list의 각 장치를 순회합니다.
    for (const device of device_list.value) {
      // 장치의 created_at 날짜를 Date 객체로 변환합니다.
      // 시간 정보는 무시하고 날짜만 비교하기 위해 "YYYY-MM-DD" 형식으로 자릅니다.
      const deviceCreatedAtDateStr = device.created_at.split(' ')[0];
      const deviceCreatedAt = new Date(deviceCreatedAtDateStr);

      // 장치 생성일이 현재 targetDate보다 이전이거나 같으면 카운트에 포함합니다.
      if (deviceCreatedAt <= targetDate) {
        count++;
      }
    }
    return count;
  });

  // 데이터가 1개일 경우 중앙에 배치
  if (accessorChartData.value.labels.length === 1) {
    accessorChartData.value.labels.unshift('')  // 왼쪽에 빈 데이터 추가
    accessorChartData.value.labels.push('')   // 오른쪽에 빈 데이터 추가
    accessorChartData.value.datasets.forEach(dataset => {
      dataset.data.unshift(null)
      dataset.data.push(null)
    })
  }

  tableData.value = accessCountMapArray.value;
};

// 차트 데이터 갱신
const updateChartData = async () => {
  loadingStore.showLoading();

  device_list.value = await GET_SERVER_REQUEST('device');
  location_list.value = await GET_SERVER_REQUEST('location', datetimeRange.value);

  await setAccess();

  if (chartInstance.value) chartInstance.value.destroy();

  if (accessorChartCanvas.value) {
    const ctx = accessorChartCanvas.value.getContext('2d');
    chartInstance.value = new Chart(ctx, {
      type: 'line',
      data: accessorChartData.value,
      options: accessorChartOptions.value,
    });
  }

  loadingStore.hideLoading();
};

onMounted(async () => {
  await nextTick(async () => {
    const today = new Date().toISOString().split('T')[0];  // YYYY-MM-DD 형식으로 현재 날짜 가져오기
    currentDate.value = Statistics_StartDate.value = Statistics_EndDate.value = today;
    
    await updateChartData();
  });
});

onUnmounted(() => {
  if (chartInstance.value) {
    chartInstance.value.destroy();
  }
});


//#region 페이지네이션
const currentPage = ref(1);
const itemsPerPage = ref(5);
const showOncePage = computed(() => { return (getIsMobile() ? 5 : 10) });
// 페이지네이션된 데이터 계산
const totalPages = computed(() =>
  Math.ceil(tableData.value?.length / itemsPerPage.value)
);
const paginatedData = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  return tableData.value?.slice(start, start + itemsPerPage.value);
});
const minPageRange = computed(() => {
  if (currentPage.value % showOncePage.value === 0) return currentPage.value - (showOncePage.value - 1);
  else return currentPage.value - ((currentPage.value % showOncePage.value) - 1);
});
const maxPageRange = computed(() => {
  let num = minPageRange.value + (showOncePage.value - 1);
  if (num > totalPages.value) num = totalPages.value
  return num;
});
const currentPageRange = computed(() => {
  const range = []
  for (let i = minPageRange.value; i <= maxPageRange.value; i++) {
    range.push(i)
  }
  return range;
});
// 페이지네이션 함수
const prevPage = () => {
  if (currentPage.value > 1) currentPage.value--;
};
const prevPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  if (num < 1) currentPage.value = 1;
  else currentPage.value = ((num - 1) * showOncePage.value) + 1;
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) currentPage.value++;
};
const nextPagePer = () => {
  const num = Math.floor(currentPage.value / showOncePage.value);
  const check = ((num + 1) * showOncePage.value) + 1
  if (check > totalPages.value) currentPage.value = totalPages.value;
  else currentPage.value = check;
};
//#endregion
</script>